import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { first } from 'rxjs/operators';

import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-auto-login',
    templateUrl: './auto-login.component.html',
    styleUrls: ['./auto-login.component.css']
})
export class AutoLoginComponent implements OnInit {

    public loading = true;

    private hasStartedAuthentication = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private environmentService: EnvironmentService
    ) { }

    ngOnInit() {
        this.environmentService.setEnvironment(environment);

        combineLatest([this.route.paramMap, this.route.queryParamMap])
            .pipe(first())
            .subscribe(([paramMap, queryParamMap]) => {
                if (this.hasStartedAuthentication) {
                    return;
                }

                const nrMd5 = this.getValue(paramMap.get('nrMd5'), queryParamMap.get('nrMd5'));
                const vinMd5 = this.getValue(paramMap.get('vinMd5'), queryParamMap.get('vinMd5'));

                if (nrMd5 && vinMd5) {
                    this.hasStartedAuthentication = true;
                    this.authenticateMd5(nrMd5, vinMd5);
                    return;
                }

                const nr = this.getValue(paramMap.get('nr'), queryParamMap.get('nr'));
                const vin = this.getValue(paramMap.get('vin'), queryParamMap.get('vin'));

                if (nr && vin) {
                    this.hasStartedAuthentication = true;
                    this.authenticatePlain(nr, vin);
                    return;
                }

                this.redirectToLogin();
            });
    }

    private authenticatePlain(registrationNumber: string, vin: string) {
        this.authenticationService.login(registrationNumber, vin, false, null)
            .pipe(first())
            .subscribe(
                data => this.handleAuthenticationResult(data),
                () => this.redirectToLogin()
            );
    }

    private authenticateMd5(registrationNumberMd5: string, vinMd5: string) {
        this.authenticationService.loginAldMd5(registrationNumberMd5, vinMd5, false)
            .pipe(first())
            .subscribe(
                data => this.handleAuthenticationResult(data),
                () => this.redirectToLogin()
            );
    }

    private handleAuthenticationResult(data: any) {
        if (data && data.Token) {
            this.router.navigate(['/home'], { replaceUrl: true });
            return;
        }

        if (data && data.TFAToken) {
            this.router.navigate(['/tfa'], { replaceUrl: true });
            return;
        }

        this.redirectToLogin();
    }

    private redirectToLogin() {
        this.loading = false;
        this.authenticationService.logout();
        this.router.navigate(['/login'], { replaceUrl: true });
    }

    private getValue(primary: string | null, fallback: string | null): string | null {
        const value = primary || fallback;

        return value ? value.trim() : null;
    }
}
